import { Alert } from '@mantine/core';

export const WorkflowsErrorAlert = ({ error }: { error: string }) => {
  return (
    <Alert my='sm' color='red'>
      An error occurred while fetching presets: {error} - Please try again later. If the problem persists, please
      contact support. You can also try refreshing the page or clearing your browser&apos;s cache and cookies.
    </Alert>
  );
};
